import React, { FC, useState } from "react";
import { Menu, MenuItem, Typography } from "@mui/material";
import classNames from "classnames";
import {
  IconHorizontalDot,
  IconTrash,
  IconShare,
  IconEye,
} from "../../../utils/icons";
import { ISinglePro } from "../../../components/singlePro/state";
import { useNavigate } from "react-router-dom";

interface Props {
  id?: string | number;
  onDelete?: (id?: string | number) => void;
  pro?: ISinglePro | null;
}

export const ExpertFormMenu: FC<Props> = ({ id, onDelete, pro }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  const onClose = () => setAnchorEl(null);

  const getMenuOption = (Icon: any, text: string, callback?: () => void) => {
    if (!callback) return null;
    return (
      <MenuItem
        className="!p-3 !px-4 flex gap-2 items-center min-w-[220px] !text-muted"
        onClick={() => {
          callback();
          onClose();
        }}
      >
        {/* stroke is an SVG attribute (no var()); inherit the token via currentColor */}
        <Icon width={24} height={24} size={24} stroke="currentColor" />
        <Typography color="var(--text-2)">{text}</Typography>
      </MenuItem>
    );
  };

  const menuId = `menu-box-${id || Math.random()}`;
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <div
        className="flex items-center justify-center"
        onClick={(event) => setAnchorEl(event.currentTarget)}
        id={menuId}
        aria-controls={anchorEl ? "single-embed-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={anchorEl ? "true" : undefined}
      >
        <div
          className={classNames(
            "flex items-center justify-center cursor-pointer border border-border-token hover:bg-surface-2 hover:border-muted p-2 bg-surface rounded-lg text-text-2",
            {
              "!bg-surface-2 !border-muted": !!anchorEl,
            },
          )}
        >
          {/* stroke is an SVG attribute (no var()); inherit the token via currentColor */}
          <IconHorizontalDot stroke="currentColor" />
        </div>
      </div>

      <Menu
        anchorEl={anchorEl}
        onClose={onClose}
        id="single-video-menu"
        aria-labelledby={menuId}
        open={!!anchorEl}
        className="py-2"
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {pro?.status === "Active" &&
          getMenuOption(IconShare, "Copy URL", () => {
            navigate(`/experts/share?proId=${id}`);
          })}
        {getMenuOption(IconEye, "View Profile", () => {
          navigate(`/experts/${id}/${pro?.slug || "-"}?proId=${id}`);
        })}
        {getMenuOption(IconTrash, "Delete", () => onDelete?.(id))}
      </Menu>
    </div>
  );
};
